import { gql } from "@apollo/client";

export const updateHostedLens = gql`
    mutation updateHostedLens($lensID: ID!, $status: HostedLensStatus!) {
        updateHostedLensStatus(input: { id: $lensID, status: $status }) {
            lens {
                id
                link
                status
                organizationId
            }
        }
    }
`;
